<template>
  <div>
    <el-form ref="form" label-width="150px" class="form">
      <el-form-item label="是否显示">
        <el-switch v-model="info.is_show"></el-switch>
      </el-form-item>

      <el-form-item label="年会员标题">
        <el-input v-model="info.year_title"></el-input>
      </el-form-item>
      <el-form-item label="年会员标题(英文)">
        <el-input v-model="info.year_title_en"></el-input>
      </el-form-item>
      <el-form-item label="年会员时长">
        <el-input v-model.number="info.year_time"></el-input>
      </el-form-item>

      <el-form-item label="月会员标题">
        <el-input v-model="info.month_title"></el-input>
      </el-form-item>
      <el-form-item label="月会员标题(英文)">
        <el-input v-model="info.month_title_en"></el-input>
      </el-form-item>
      <el-form-item label="月会员时长">
        <el-input v-model.number="info.month_time"></el-input>
      </el-form-item>

      <!-- <el-form-item label="年会员标题">
        <el-input v-model="info.year_title"></el-input>
      </el-form-item>
      <el-form-item label="年会员标题(英文)">
        <el-input v-model="info.year_title_en"></el-input>
      </el-form-item>
      <el-form-item label="年会员时长">
        <el-input v-model.number="info.time"></el-input>
      </el-form-item> -->

      <el-form-item label="按月续费价格">
        <el-input v-model="info.month_price"></el-input>
      </el-form-item>
      <el-form-item label="按月续费(划线价)">
        <el-input v-model="info.month_underline_price"></el-input>
      </el-form-item>
      <el-form-item label="按年续费价格">
        <el-input v-model="info.year_price"></el-input>
      </el-form-item>
      <el-form-item label="按年续费(划线价)">
        <el-input v-model="info.year_underline_price"></el-input>
      </el-form-item>
      <el-form-item label="服务期描述(中文)">
        <el-input v-model="info.description"></el-input>
      </el-form-item>
      <el-form-item label="服务期描述(英文)">
        <el-input v-model="info.description_en"></el-input>
      </el-form-item>
      <el-form-item label="会员权益(中文)">
        <el-input type="textarea" rows="5" v-model="info.rule_1"></el-input>
      </el-form-item>
      <el-form-item label="会员权益(英文)">
        <el-input type="textarea" rows="5" v-model="info.rule_1_en"></el-input>
      </el-form-item>
      <el-form-item label="服务声明(中文)">
        <el-input type="textarea" rows="5" v-model="info.rule_2"></el-input>
      </el-form-item>
      <el-form-item label="服务声明(英文)">
        <el-input type="textarea" rows="5" v-model="info.rule_2_en"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import request from '@/utils/request'
  export default {
    name: 'VipSetting',
    props: {
      type: {
        type: 'string',
        default: _ => {
          return 'cef'
        }
      }
    },
    data() {
      return {
        info: {}
      }
    },
    mounted() {
      request({
        url: '/vip-setting',
        method: 'GET',
        params: {
          type: this.type,
        }
      }).then(res => {
        this.info = res.data.setting || {}
      })
    },
    methods: {
      submit() {
        request({
          url: '/vip-setting',
          method: 'POST',
          data: {
            type: this.type,
            setting: this.info
          }
        }).then(res => {
          this.$message.success('保存成功!')
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .form {
    width: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/views/vip/components/vipSetting.vue